export const lowerdash = string => {
  return string.replace(/\s+/g, '-').toLowerCase()
}